// extracted by mini-css-extract-plugin
export default {"OsmMarkerPopUp":"style_OsmMarkerPopUp__RcBSE","OsmMarkerPopUpName":"style_OsmMarkerPopUpName__PUX5N","OsmMarkerPopUpButton":"style_OsmMarkerPopUpButton__ruMen"};